import { IProduct } from "./product";

export interface IDocument extends IDocumentPOST {
	_id: string;
	products_enriched?: (IProduct | undefined)[];
	revisions: IRevision[];
	createdBy: string;
	createdAt: string; // string (formato 2024-10-02T15:51:51.000Z);
	updatedAt: string; // string (formato 2024-10-02T15:51:51.000Z);
	deleted?: boolean;
}

export interface IDocumentPOST {
	documentName: string;
	status: TDocumentStatus;
	visibility: "public" | "private";
	categories: string[];
	products: string[];
	locale: string[];
	markets: string[];
	code?: string;
	notes: string;
	revisions?: IRevisionPOST[];
	assignedTo?: string;
	updatedBy?: string;
	hiddenOnLanding: boolean; // Field for visibility on the landing page
	deleted?: boolean; // Field for visibility on FE
}

export interface IRevisionPOST {
	filename: string;
	status: TRevisionStatus;
	validityStartDate: Date; // string (formato 2024-10-02T15:51:51.000Z);
	validityEndDate: Date; // string (formato 2024-10-02T15:51:51.000Z);
	internalRevisionDate: Date; // string (formato 2024-10-02T15:51:51.000Z);
	manualRevisionNumber: string;
	changeRegistry?: string;
	publicDescription?: string;
	deleted?: boolean;
	contentType: string;
}

export interface IRevision extends IRevisionPOST {
	automaticRevisionNumber: string;
	fileLocation: string;
	thumbUrl: string;
	fileUrl: string;
	file: File;
}

export enum DOCUMENT_ROLE {
	tim = "tim_cosmogas",
	cat = "cat_cosmogas",
	rivenditore = "rivenditore",
	installatore = "installatore",
	privato = "privato",
	progettista = "progettista",
	subscriber = "subscriber",
	administrator = "administrator",
	cosmogas = "cosmogas",
}

export enum DOCUMENT_GROUP {
	accesso_documentale = "accesso_documentale",
	accesso_certificati = "accesso_certificati",
	accesso_www = "accesso_www",
	accesso_cosmoclub = "accesso_cosmoclub",
	accesso_acquacalda = "accesso_acquacalda",
	accesso_ricambi = "accesso_ricambi",
}

export enum DOCUMENT_LOCALE {
	"italiano-italia" = "IT",
	"inglese-usa" = "EN/US",
	"inglese-uk" = "EN/UK",
	"francese-francia" = "FR",
	"spagnolo-spagna" = "ES",
	"romeno-romania" = "RO",
	"ungherese-ungheria" = "HU",
	"greco-grecia" = "GR",
	"tedesco-germania" = "DE",
	"olandese-olanda" = "NL",
	"ceco-repubblica-ceca" = "CZ",
	"polacco-polonia" = "PL",
	"portoghese-portogallo" = "PT",
	"russo-russia" = "RU",
	"turco-turchia" = "TU",
}

export enum I18N_LOCALE_TO_DOCUMENT_LOCALE {
	it = "italiano-italia",
	"en-US" = "inglese-usa",
	en = "inglese-uk",
	fr = "francese-francia",
	es = "spagnolo-spagna",
	ro = "romeno-romania",
	hu = "ungherese-ungheria"
}

export enum DOCUMENT_MARKET {
	IT_IT = "IT-IT",
	BG_BG = "BG-BG",
	DE_AT_Olymp = "DE-AT - Olymp",
	EN_CN = "EN-CN",
	EN_KR = "EN-KR",
	EN_MX = "EN-MX",
	EN_UK = "EN-UK",
	EN_US = "EN-US",
	EN_US_Aerco = "EN-US - Aerco",
	EN_US_RBI = "EN-US - RBI",
	ES_ES = "ES-ES",
	FR_FR = "FR-FR",
	FR_US = "FR-US",
	FR_US_Aerco = "FR-US - Aerco",
	FR_US_RBI = "FR-US - RBI",
	FR_TN = "FR-TN",
	GR_GR = "GR-GR",
	HU_HU = "HU-HU",
	PL_PL = "PL-PL",
	PT_PT = "PT-PT",
	RO_RO = "RO-RO",
	RU_RU = "RU-RU",
	EN_UK_Gemtex = "EN-UK - Gemtex",
	EN_UK_Adveco = "EN-UK - Adveco",
	EN_NL_Lochinvar = "EN-NL - Lochinvar",
	NL_NL_Aosmith = "NL-NL - Aosmith",
	FR_FR_Engie = "FR-FR - Engie",
	DE_DE = "DE-DE",
	CZ_CZ = "CZ-CZ",
	// XX_XX = "XX-XX",
}

export enum DOCUMENT_STATUS {
	published = "Published",
	draft = "Draft",
	canceled = "Canceled",
}

export enum DOCUMENT_CATEGORY_ENUM {
	manuali = "manuali",
	manuali_accessori = "manuali_accessori",
	manuali_progettisti = "manuali_progettisti",
	istruzioni = "istruzioni",
	certificazioni = "certificazioni",
	centri_assistenza = "centri_assistenza",
	depliant = "depliant",
	detrazioni = "detrazioni",
	schede_erp_detrazioni = "schede_erp_detrazioni",
	conto_termico_detrazioni = "conto_termico_detrazioni",
	dimensionali = "dimensionali",
	listini = "listini",
	modulistica = "modulistica",
	schede_tecniche = "schede_tecniche",
	conoscere_insieme = "conoscere_insieme",
	bim_project = "bim_project",
	referenze = "referenze",
	altro = "altro",
}

export enum DOCUMENT_VISIBILITY {
	public = "public",
	private = "private",
}

export type TDocumentStatus = "published" | "draft" | "deleted";
export type TRevisionStatus = TDocumentStatus;
